
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { CompanyConfig, MailConfig } from '@/installationConfig';

import {
  ContactsClient,
  QuotationsClient,
  IMailQuotationCommand,
  MailQuotationCommand,
  IQuotationDetailedDto,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  MailTemplatesClient,
  MailTemplateType,
  MailTemplateDto,
  IMailTemplateDto,
  ProjectContactsClient,
  QuotationStatus,
} from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class MailPopup extends Vue {
  show: boolean = false;
  sending: boolean = false;
  fullscreen: boolean = false;
  formdata: IMailQuotationCommand | any = {
    template: '',
    from: '',
    to: [],
    cc: [],
    replyTo: [],
    subject: '',
    content: '',
    sendSms: true,
    objectId: '',
    language: '',
  };
  templates: IMailTemplateDto[] = [];

  //clients
  projectContactsClient: ProjectContactsClient = new ProjectContactsClient(undefined, this.$axios);
  mailTemplatesClient: MailTemplatesClient = new MailTemplatesClient(undefined, this.$axios);

  @Prop({ required: true })
  quotation!: IQuotationDetailedDto;

  public async open() {
    this.formdata.to.splice(0, this.formdata.to.length);
    this.formdata.cc.splice(0, this.formdata.cc.length);
    this.loadProjectContacts();

    if (this.quotation.customerContact && this.quotation.customerContact.email && this.quotation.customerContact.email !== '') {
      (this.formdata.to as string[]).push(this.quotation.customerContact.email);
    } else if (this.quotation.customer && this.quotation.customer.email && this.quotation.customer.email !== '') {
      (this.formdata.to as string[]).push(this.quotation.customer.email);
    }

    this.formdata.objectId = this.quotation.id;

    const lastUsedEmail = localStorage.getItem('quotation_last_used_email');
    const lastUsedTemplate = localStorage.getItem('quotation_last_used_template');
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (this.quotation.internalContactMail != undefined) {
      this.formdata.replyTo.push(this.quotation.internalContactMail);
    }

    if (lastUsedTemplate) {
      this.formdata.template = lastUsedTemplate;
      const template = this.templates.find((o) => o.name === lastUsedTemplate);
      if (template) {
        this.formdata.subject = template.subject ? this.replaceTags(template.subject) : '';
        this.formdata.content = template.content ? this.replaceTags(template.content) : '';
      }
      this.show = false;
    }

    this.show = true;
  }

  async loadProjectContacts() {
    if (!this.quotation.projectId || this.quotation.projectId === '') {
      return;
    }

    const res = await this.projectContactsClient.getContacts(this.quotation.projectId);
    res.forEach((contact) => {
      if (contact.sendQuotation && contact.contact && contact.contact.email && contact.contact.email !== '') {
        if (this.formdata.to.indexOf(contact.contact.email) === -1) {
          this.formdata.to.push(contact.contact.email);
        }
      }
    });
  }

  async created() {
    try {
      this.templates = await this.mailTemplatesClient.getAll(MailTemplateType.Quotation);
    } catch {
      // do nothing
    }
  }

  replaceTags(content: string) {
    let replacedContent = content;
    const self = this;
    try {
      let contact = null;
      if (this.quotation) {
        if (this.quotation.customerContact) {
          contact = this.quotation.customerContact;
        } else if (this.quotation.customer) {
          contact = this.quotation.customer;
        }
      }

      while (replacedContent.indexOf('#Name') !== -1) {
        replacedContent = replacedContent.replace('#Name', contact ? contact.displayName! : '');
      }

      while (replacedContent.indexOf('#Quotation_DocumentNumber') !== -1) {
        replacedContent = replacedContent.replace('#Quotation_DocumentNumber', CompanyConfig.companyName == "OneSkin" ? this.quotation.documentNumber!.replace("OFF/", "")  : this.quotation.documentNumber!);
      }

      while (replacedContent.indexOf('#Quotation_DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Quotation_DocumentNumber', CompanyConfig.companyName == "OneSkin" ? this.quotation.documentNumber!.replace("OFF/", "")  : this.quotation.documentNumber!);
      }

      if (contact && contact.type === 'Contact') {
        const splittedName = contact.displayName ? contact.displayName.split(' ') : null;
        if (splittedName && splittedName.length > 0) {
          const firstname = splittedName[0];
          const lastname = contact.displayName!.replace(firstname, '');

          while (replacedContent.indexOf('#Contact_Firstname') !== -1) {
            replacedContent = replacedContent.replace('#Contact_Firstname', firstname);
          }

          while (replacedContent.indexOf('#Contact_Lastname') !== -1) {
            replacedContent = replacedContent.replace('#Contact_Lastname', lastname);
          }
        }
      }

      while (replacedContent.indexOf('#Contact_Firstname') !== -1) {
        replacedContent = replacedContent.replace('#Contact_Firstname', '');
      }

      while (replacedContent.indexOf('#Contact_Lastname') !== -1) {
        replacedContent = replacedContent.replace('#Contact_Lastname', '');
      }

      while (replacedContent.indexOf('#Contact_Lastname') !== -1) {
        replacedContent = replacedContent.replace('#Contact_Lastname', '');
      }

      while (replacedContent.indexOf('#Project_Name') !== -1) {
        if (this.quotation && this.quotation.projectName) {
          replacedContent = replacedContent.replace('#Project_Name', this.quotation.projectName);
        }
      }

      while (replacedContent.indexOf('#Project_DocumentNumber') !== -1) {
        if (this.quotation && this.quotation.projectDocumentNumber) {
          replacedContent = replacedContent.replace('#Project_DocumentNumber', this.quotation.projectDocumentNumber);
        }
      }
    } catch {
      // do nothing
    }

    return replacedContent;
  }

  async send() {
    try {
      if (this.formdata.from) {
        localStorage.setItem('quotation_last_used_email', this.formdata.from);
        localStorage.setItem('quotation_last_used_template', this.formdata.template);
      }

      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.sending = true;
      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>');
      await new QuotationsClient(undefined, this.$axios).mail(new MailQuotationCommand(this.formdata));
      notificationService.showSuccessMessage('Mail verstuurd');
      if (this.quotation.status === QuotationStatus.Draft || this.quotation.status === QuotationStatus.Open) {
        this.quotation.status = QuotationStatus.Send;
      }

      this.$emit('mailSend');
      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }
          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              projectId: this.quotation.projectId,
              options: new DataSourceLoadOptionsBase(
                Object.assign({}, loadOptions, {
                  stringToLower: true,
                })
              ),
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: this.quotation.projectId ? false : true,
    });
  }

  get contactOptions() {
    const self = this;
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    const self = this;
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.content = self.replaceTags(e.itemData.content);
        self.formdata.subject = self.replaceTags(e.itemData.subject);
        self.formdata.language = e.itemData.language;
      },
    };
  }
}
